import { faEnvelope, faLocationDot, faPhone, faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { getValueOrPlaceHolder, maskContactNumber } from '../../../../../Utils/helpers/commonhelper'
import imgs from "../../../../../Utils/assets/img/company-concept.png";
import useLocalStorageState from 'use-local-storage-state'

// initCompanyData = 'company at first index. ' so rather passing the complete company object i will pass only the company data at index 1
export const CompanyPrimaryInfo = ({ companyData }) => {
    const [customer] = useLocalStorageState('customer')
    const [expandedItems, setExpandedItems] = useState({});
    const [expanded, setExpanded] = useState(false)


    // Helper functions to parse JSON data
    const parseUserPhone = (phoneData) => {
        try {
            if (typeof phoneData === "string") {
                const parsed = JSON.parse(phoneData);
                return Array.isArray(parsed) ? parsed[0] : parsed;
            }
            return phoneData;
        } catch {
            return null;
        }
    };

    const parseUserEmail = (emailData) => {
        try {
            if (typeof emailData === "string") {
                const parsed = JSON.parse(emailData);
                return Array.isArray(parsed) ? parsed[0] : parsed;
            }
            return emailData;
        } catch {
            return null;
        }
    };

    const userPhone = parseUserPhone(companyData[0]?.user_phone);
    const userEmail = parseUserEmail(companyData[0]?.user_email);

    // Render star rating
    const renderStarRating = (rating) => {
        const stars = [];
        const numRating = Number.parseInt(rating) || 0;
        for (let i = 0; i < 5; i++) {
            stars.push(
                <FontAwesomeIcon
                    key={i}
                    icon={faStar}
                    style={{
                        fontSize: "12px",
                        color: i < numRating ? "#dfd113" : "#ddd",
                    }}
                />
            );
        }
        return stars;
    };

    const hideShow = (contents) => {
        const charLimit = 84; // Change this to any limit you want
        const isTruncatedss = contents.length > charLimit;
        const previews = contents.slice(0, charLimit);

        return (
            <>
                {expanded || !isTruncatedss ? contents : previews + "..."}
                {isTruncatedss && (
                    <span
                        onClick={() => setExpanded(!expanded)}
                        style={{ color: "blue", cursor: "pointer", marginLeft: "3px" }}
                    >
                        {expanded ? "Less" : " More"}
                    </span>
                )}
            </>
        );
    };

    return (
        <div
            className="me-2"
            style={{
                background: "#fff",
                paddingTop: "12px",
                borderRadius: "5px",
                border: "1px solid #e0e4f8",
                marginBottom: "10px",
            }}
        >
            <div
                className="d-flex gap-3 ms-3  mb-0 pb-0 pt-3"
                style={styles.stickyHeader}
            >
                <div style={{ width: "10%" }}>
                    <div
                        className="overflow-hidden border border-2 d-flex justify-content-center align-items-center"
                        style={{
                            width: "100%",
                            height: "86%",
                            backgroundColor: "#fff",
                            borderColor: "#7a3a5e",
                            backgroundImage: companyData[0].company_image
                                ? `url(${companyData[0].company_image})`
                                : `url(${imgs})`,
                            backgroundPosition: "center",
                            backgroundSize: "111%",
                            backgroundRepeat: "no-repeat",
                        }}
                    ></div>
                </div>
                <div style={{ width: "85%" }}>
                    <div
                        style={{
                            color: "#576f91",
                            fontSize: "13px",
                            fontWeight: 500,
                        }}
                        className="d-flex justify-content-between align-items-center"
                    >
                        <div>
                            <h4
                                className="mb-1 d-flex align-items-center"
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    color: "#3c3c3c",
                                }}
                            >
                                <span className="companyOffcanvasName">
                                    {companyData[0].company_name || "Company Name"}
                                </span>
                                <span
                                    style={{ color: "#3f97fd", marginLeft: "4px" }}
                                >
                                    ({companyData[0]?.company_no && "#"}{getValueOrPlaceHolder(companyData[0].company_no)})
                                </span>
                                <span
                                    style={{
                                        verticalAlign: "super",
                                        marginLeft: "4px",
                                    }}
                                >
                                    {renderStarRating(companyData[0].rating)}
                                </span>
                            </h4>
                            <p className="mb-0 d-flex align-items-center gap-2">
                                {getValueOrPlaceHolder(companyData[0].industry, "No Industry")} <span>|</span>
                                {getValueOrPlaceHolder(companyData[0].business_type, "No Buisness Type")}
                            </p>
                        </div>
                    </div>
                    <div
                        className="  pt-3 ps-0 pb-0"
                        style={{
                            background: "transparent",
                            marginTop: "0rem",
                            marginLeft: "0rem",
                        }}
                    >
                        <Row className="w-100 ms-0 mb-2 ">
                            <Col
                                md={6}
                                className="mb-3 d-flex align-items-center"
                            >
                                <FontAwesomeIcon
                                    icon={faEnvelope}
                                    style={styles.iconsStyles}
                                    className=" fs-16"
                                />
                                <div>
                                    <p className="mb-0" style={styles.labels}>
                                        Email
                                    </p>
                                    <p className="mb-0" style={styles.values}>
                                        {getValueOrPlaceHolder(userEmail?.email ||
                                            companyData[0].email, "No Email")}
                                    </p>
                                </div>
                            </Col>
                            <Col
                                md={6}
                                className="mb-3 d-flex align-items-center"
                                // onClick={() => checkTwilio()}
                                style={{ cursor: 'pointer' }}
                            >
                                <FontAwesomeIcon
                                    icon={faPhone}
                                    style={styles.iconsStyles}
                                    className=" fs-16"
                                />
                                <div>
                                    <p className="mb-0" style={styles.labels}>
                                        Phone
                                    </p>
                                    <p className="mb-0" style={styles.values}>
                                        {
                                            userPhone?.phone
                                                ?
                                                `${userPhone.country_code} ${maskContactNumber(customer, userPhone.phone)}`
                                                : <p style={{ display: "inline-block", fontSize: "13px", color: "#afafaf" }}>No Phone</p>
                                        }
                                    </p>
                                </div>
                            </Col>
                            <Col
                                md={6}
                                className="mb-3 d-flex align-items-center"
                            >
                                <FontAwesomeIcon
                                    icon={faLocationDot}
                                    className=" fs-16"
                                    style={styles.iconsStyles}
                                />
                                <div>
                                    <p className="mb-0" style={styles.labels}>
                                        Address
                                    </p>
                                    <div className="mb-0" style={styles.values}>
                                        {companyData[0].address ? hideShow(`${companyData[0].address}`) : getValueOrPlaceHolder(companyData[0].address)}
                                    </div>
                                </div>
                            </Col>
                            <Col
                                md={6}
                                className="mb-3 d-flex align-items-center"
                            >
                                <FontAwesomeIcon
                                    icon={faLocationDot}
                                    className=" fs-16"
                                    style={styles.iconsStyles}
                                />
                                <div>
                                    <p className="mb-0" style={styles.labels}>
                                        Website
                                    </p>
                                    <p className="mb-0" style={styles.values}>
                                        {getValueOrPlaceHolder(companyData[0].website)}
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    )
}

const styles = {
    stickyHeader: {
        paddingBottom: "11px",
        position: "sticky",
        background: "#fff",
        top: "0px",
    },
    labels: {
        fontSize: "12px",
        color: "#B0BAC9",
        fontWeight: 400,
    },
    iconsStyles: {
        color: "#2656a8",
        border: "1px solid #e6e6e6",
        background: "#e9f1ff",
        padding: "9px",
        borderRadius: "50%",
        marginRight: "10px",
        width: "15px",
        height: "15px",
        fontSize: "13px",
    },
    values: {
        color: "#2e384d",
        fontWeight: 400,
        fontSize: ".8333rem",
        letterSpacing: '0.25px',
    },
};